import { PropsWithChildren } from 'react';

import styles from './RootLayout.module.scss';

// Fullscreen Layout with relative position, for elements that should overlap mediaQueries of Section Layout
export const RootLayout = ({ children }: PropsWithChildren) => <div className={styles.container}>{children}</div>;
